import { memo } from "react";

import { Box } from "@mui/material";
import { ClassIcon, GroupsIcon } from "../../../../2_ksbHub/icons/icons";

import KsbAppBar from "../../../../2_ksbHub/components/KsbAppBar";
import KsbAppToolbarContainer from "../../../../2_ksbHub/components/KsbAppToolbarContainer";
import KsbToolbarUser from "../../../../2_ksbHub/components/KsbToolbarUser";
import KsbActionButton from "../../../../2_ksbHub/components/KsbActionButton";

import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import { useBszPlannerContext } from "../../context/bszPlannerContext";
import KsbSelector from "../../../../2_ksbHub/components/KsbSelector";

function BSZPlannerHeader() {
  const { isStudentView, isTeacherView, isMobile } = useAppContext();
  const {
    isBszAdmin,
    setShowClassesAdminDialog,
    setShowClassesDialog,
    schoolyears,
    selectedSchoolyear,
    setSelectedSchoolyear,
  } = useBszPlannerContext();

  // const viewOptions = [
  //   { id: "timeline", label: "Timeline" },
  //   { id: "workload", label: "Workload" },
  //   { id: "deadline", label: "Deadlines" },
  //   { id: "mine", label: "Meine Projekte" },
  // ];

  return (
    <KsbAppBar>
      <KsbAppToolbarContainer>
        <KsbToolbarUser sx={{ width: "100%", justifyContent: "space-between" }}>
          {/* ✅ LEFT SIDE */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* <KsbSelector
              value={viewMode}
              options={viewOptions}
              getValue={(v) => v.id}
              getLabel={(v) => v.label}
              onChange={setViewMode}
            /> */}
            {schoolyears.length > 0 && (
              <KsbSelector
                value={selectedSchoolyear?.id}
                options={schoolyears}
                getValue={(y) => y.id}
                getLabel={(y) => (isMobile ? y.label.slice(2) : y.label)}
                onChange={(id) => {
                  const sy = schoolyears.find((y) => y.id === id);
                  if (sy) setSelectedSchoolyear(sy);
                }}
              />
            )}
          </Box>

          {/* ✅ RIGHT SIDE */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {isBszAdmin && !isTeacherView && !isStudentView && (
              <KsbActionButton
                label="Klassen +"
                icon={<ClassIcon />}
                desktopIcon={<ClassIcon />}
                onClick={() => setShowClassesAdminDialog(true)}
                sx={{ ml: 1 }}
              />
            )}

            <KsbActionButton
              label="Klassen"
              icon={<GroupsIcon />}
              desktopIcon={<GroupsIcon />}
              onClick={() => setShowClassesDialog(true)}
            />
          </Box>
        </KsbToolbarUser>
      </KsbAppToolbarContainer>
    </KsbAppBar>
  );
}

export default memo(BSZPlannerHeader);
